module.exports = __webpack_public_path__ + "img/pic_turbomode_speed1@3x.030778fa.png";